import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ActivityRecordService } from 'src/app/services/activity-record.service';

@Component({
  selector: 'app-view-farmer-application',
  templateUrl: './view-farmer-application.component.html',
  styleUrls: ['./view-farmer-application.component.scss']
})
export class ViewFarmerApplicationComponent implements OnInit {

  userID: any;
  appId: any;
  
  constructor(
    private route: ActivatedRoute,
    private activityRecordService: ActivityRecordService
  ) { }

  ngOnInit(): void {
    this.appId = this.route.snapshot.paramMap.get('appId');

    let sessionToken = sessionStorage.getItem('token');
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;
    this.activityRecordService.activityRecord(this.userID, 'View Farmer Application', this.appId, new Date(), 'Success');
  }

}
